import { useCallback, useMemo } from "react"

import {
  DatePickerFilterProps,
  DefaultDatePickerFilter,
  RangeDateFilterInput,
} from "../DatePickerFilter"
import { DateFilterOperator } from "../date-filter.types"

type ComponentOperatorMapping = {
  operators: DateFilterOperator[]
  component: React.ReactNode
}

export const useComponentOperatorMapping = (props: DatePickerFilterProps) => {
  const componentOperatorMapping = useMemo<ComponentOperatorMapping[]>(() => {
    return [
      {
        operators: [DateFilterOperator.between, DateFilterOperator.notBetween],
        component: <RangeDateFilterInput {...props} />,
      },
      {
        operators: [
          DateFilterOperator.equals,
          DateFilterOperator.before,
          DateFilterOperator.after,
          DateFilterOperator.notEquals,
          DateFilterOperator.beforeOrEquals,
          DateFilterOperator.afterOrEquals,
        ],
        component: <DefaultDatePickerFilter {...props} />,
      },
      {
        operators: [DateFilterOperator.empty, DateFilterOperator.notEmpty],
        component: null,
      },
    ]
  }, [props])

  const getComponentForOperator = useCallback(
    (operator: DateFilterOperator): React.ReactNode => {
      const mapping = componentOperatorMapping.find((mapping) =>
        mapping.operators.includes(operator)
      )

      if (!mapping) {
        return null
      }

      return mapping.component
    },
    [componentOperatorMapping]
  )

  return {
    getComponentForOperator,
    componentOperatorMapping,
  }
}
